<template>
  <div v-if="localShow" class="modal-overlay" @click="closeModal">
    <div class="modal-dialog" @click.stop>
      <BaseDialog
        :title="'Create New Project'"
        :footerButtons="['Cancel', 'Create']"
        @cancel="closeModal"
        @create="createProject"
      >
        <div class="settings__control-group">
          <label class="required">Name</label>
          <input
            v-model="createNewName"
            class="select"
            type="text"
          >
        </div>
        <div class="settings__control-group">
          <label>Description</label>
          <textarea
            v-model="createNewDescription"
            rows="2"
            cols="50"
          />
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import BaseDialog from '@/components/DilaogTemplate/BaseDialog.vue';

export default {
  name: 'ProjectCreate',
  components: {
    BaseDialog,
  },
  emits: {
    'create-project': null,
  },
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      createNewName: '',
      createNewDescription: '',
      localShow: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  methods: {
    showModal() {
      this.getUsersListByOrganization(this.user.organization_id);
      this.localShow = true;
    },
    clearData() {
      this.createNewName = '';
      this.createNewDescription = '';
    },
    closeModal() {
      this.clearData();
      this.localShow = false;
    },
    createProject() {
      const args = {
        project_name: this.createNewName,
        description: this.createNewDescription,
      };

      this.$emit('create-project', args);
      this.closeModal();
    },
    async getUsersListByOrganization(id) {
      await this.dsConn.getUserListByOrganization({
        organization_id: id,
      })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.modal-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

